var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcendingIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.329102 0.953125H6.3291L6.3291 2.95312H0.329102L0.329102 0.953125ZM0.329102 12.9531L0.329102 10.9531L18.3291 10.9531V12.9531L0.329102 12.9531ZM0.329102 5.95312L12.3291 5.95312V7.95312L0.329102 7.95312L0.329102 5.95312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcendingIconSvg);
export default __webpack_public_path__ + "static/media/acendingIconSvg.c10079946938b4f8f1d472aefa49b85f.svg";
export { ForwardRef as ReactComponent };